<template>
  <UILoader class="asb-banner-events" :grow="grow" :loading="getCentralEvents.loading" column>
    <UIScroller>
      <template v-for="item in items">
        <UIBox :key="item.Id" class="asb-banner-events__item">
          <CBanner
            v-if="item.type === 'banner'"
            :banner="item"/>
          <component
            v-else
            :is="componentName"
            :event="item"
            :isLoading="isGetCentralEventsLoading"/>
        </UIBox>
      </template>
    </UIScroller>
  </UILoader>
</template>

<script>
import CEventRow from '@/components/CEventRow/CEventRow'
import CEventCard from '@/components/CEventCard/CEventCard.vue'
import CBanner from '@/components/CBanner/CBanner.vue'
import Requests from '@altenar/transport'
import { EventFunctions } from '@altenar/models'
import { getBannersIdxByEventsCount } from '@/utils/carouselBannersUtil.ts'

export default {
  name: 'WBannerEvents',
  props: {
    isEventCardView: {
      type: [Boolean, String],
      default: false
    },
    banners: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      getCentralEvents: new Requests.GetCentralEvents(),
      isGetCentralEventsLoading: true,
      items: []
    }
  },
  beforeDestroy() {
    this.getCentralEvents.stop()
  },
  created() {
    this.getCentralEvents.fetchRequest({})
    this.getCentralEvents.isLoading = loading => {
      this.isGetCentralEventsLoading = loading
    }
    this.getCentralEvents.onSuccess = result => {
      const resultEvents = EventFunctions.extractEventsFromTree(result)
      this.items = EventFunctions.parseEvents(resultEvents)
      if (this.parsedBanners) {
        const eventsCount = this.items.length
        const bannersCount = this.parsedBanners.length || 0
        const bannersPositions = getBannersIdxByEventsCount({eventsCount, bannersCount})
        for (const [index, position] of bannersPositions.entries()) {
          this.items.splice(position, 0, {...this.parsedBanners[index], type: 'banner'})
        }
      }
    }
  },
  computed: {
    componentName() {
      return this.isEventCardView ? 'CEventCard' : 'CEventRow'
    },
    parsedBanners() {
      return this.banners ? JSON.parse(this.banners) : null
    }
  },
  components: { CEventRow, CEventCard, CBanner }
}
</script>
